import React, { useContext } from 'react';
import { GoHome } from "react-icons/go";
import { HiOutlineCalculator, HiOutlineUserGroup } from "react-icons/hi2";
import { TbBuildingBank, TbFileReport, TbReceiptTax } from "react-icons/tb";
import { VscSettings } from "react-icons/vsc";

import { routes } from '@/app/constants';
import { CircleInitial } from '@/shared/ui/CircleInitial/CircleInitial';

import { CompanyManagementModalAPI } from '@/features/Modals/CompanyManagementModal/CompanyManagementModal';
import { useLoadingSpinner } from '../../../app/providers/LoadingSpinnerProvider/LoadingSpinnerProvider';
import { CompanyContext } from '../../../app/providers/ParamsProvider/ParamsProvider';
import { MenuItemType, SidebarItem } from './types';

export const sidebarItems = (): SidebarItem[] => {
    const { showLoading, hideLoading } = useLoadingSpinner();
    const companyInfo = useContext(CompanyContext);

    return [
        {
            title: '자료수집관리',
            icon: <GoHome />,
            menuType: MenuItemType.BUTTON,
            to: '/main',
        },
        {
            title: '회계관리',
            icon: <HiOutlineCalculator />,
            menuType: MenuItemType.BUTTON,
            to: routes.Accounting.AccountingMain.path,
        },
        {
            title: '부가가치세',
            icon: <TbReceiptTax />,
            menuType: MenuItemType.BUTTON,
            to: routes.Vat.VatMain.path,
        },
        {
            title: '급여보험',
            icon: <HiOutlineUserGroup />,
            menuType: MenuItemType.BUTTON,
            to: routes.SalaryInsurance.SalaryInsuranceMain.path,
        },
        {
            title: '법인조정',
            icon: <TbBuildingBank />,
            menuType: MenuItemType.BUTTON,
            to: routes.Coperate.CorporateAdjustmentMain.path,
        },
        {
            title: '개인조정',
            icon: <TbFileReport />,
            menuType: MenuItemType.BUTTON,
            to: routes.Personal.PersonalAdjustmentMain.path,
        },
        {
            title: '회사설정',
            icon: <VscSettings />,
            menuType: MenuItemType.BUTTON,
            onClick: () => {
                const workspaceName = companyInfo?.workspace?.workspaceName;
                const companyId = companyInfo?.company?.companyId;
                window.open(`https://www.xadom.ai/${workspaceName}/company-management?cId=${companyId}`, '_blank');
            }
        },
    ];
};

export const bottomSidebarItems = (): SidebarItem[] => {
    const companyInfo = useContext(CompanyContext);
    
    return [
        {
            title: companyInfo?.company?.korName || '회사명',
            icon: <CircleInitial text={companyInfo?.company?.korName || '회사명'} />,
            menuType: MenuItemType.BUTTON,
            onClick: () => {
                CompanyManagementModalAPI.show();
            }
        },
    ];
};
